import styled, { css } from "styled-components";

const CashbackItemWrapperStyled = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 15px;
	background: var(--input-bg-has-value);
	width: 100%;
	overflow: hidden;
`;

const CashbackItemHeaderStyled = styled.div`
	display: flex;
	padding: 8px 12px;
	justify-content: space-between;
	align-items: center;
	background: var(--main-explosive-gradient-020);
	color: #f7f7fc;
	font-size: 12px;
	font-weight: 600;
	line-height: 16px;
	letter-spacing: 0.3px;
	gap: 10px;

	@media (min-width: 768px) {
		font-size: 14px;
		line-height: 20px;
	}
`;

const CashbackItemTitleStyled = styled.div`
	display: flex;
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

const CashbackItemBodyStyled = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px;
	gap: 12px;

	@media (min-width: 768px) {
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 14px 16px;
	}
`;

const CashbackItemAmountBlockStyled = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

const CashbackItemAmountLabelStyled = styled.div`
	color: #a0a3bd;
	font-size: 10px;
	font-weight: 500;
	line-height: 14px;
	letter-spacing: 0.3px;
	text-transform: uppercase;
`;

const CashbackItemAmountValueStyled = styled.div`
	color: #f7f7fc;
	font-size: 18px;
	font-weight: 700;
	line-height: 24px;
	letter-spacing: 0.3px;

	${({ muted }) =>
		muted &&
		css`
			color: #a0a3bd;
			font-weight: 600;
		`}
`;

const CashbackItemStatusMessageStyled = styled.div`
	color: #a0a3bd;
	font-size: 12px;
	font-weight: 400;
	line-height: 18px;
	letter-spacing: 0.3px;
	flex: 1;

	@media (min-width: 768px) {
		text-align: center;
		padding: 0 12px;
	}
`;

const CashbackItemClaimButtonStyled = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 40px;
	min-width: 120px;
	padding: 0 20px;
	border-radius: 25px;
	background: var(--main-explosive-gradient, #eebf12);
	color: #1f232d;
	font-size: 12px;
	font-weight: 700;
	line-height: 20px;
	letter-spacing: 0.5px;
	text-transform: uppercase;
	border: none;
	cursor: pointer;
	transition: opacity 0.15s ease;

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	@media (min-width: 768px) {
		min-width: 140px;
	}
`;

export {
	CashbackItemAmountBlockStyled,
	CashbackItemAmountLabelStyled,
	CashbackItemAmountValueStyled,
	CashbackItemBodyStyled,
	CashbackItemClaimButtonStyled,
	CashbackItemHeaderStyled,
	CashbackItemStatusMessageStyled,
	CashbackItemTitleStyled,
	CashbackItemWrapperStyled,
};
